/* eslint react/jsx-props-no-spreading: ["off"] */

import React from 'react'
import { CardContent } from './styles'

export default function Card(props) {
  return (
    <CardContent {...props} />
  )
}
